import { createI18n } from 'vue-i18n';
import Store from '@/store';
import elementEnLocale from 'element-plus/es/locale/lang/en'; // 英文
import elementZhLocale from 'element-plus/es/locale/lang/zh-cn'; // 中文
import elementThLocale from 'element-plus/es/locale/lang/th'; // 泰文
import elementEsLocale from 'element-plus/es/locale/lang/es'; // 西班牙语墨西哥
import elementIdLocale from 'element-plus/es/locale/lang/id'; // 印尼文

import AvueEnLocale from '@smallwei/avue/lib/locale/lang/en'; // 英文
import AvueZhLocale from '@smallwei/avue/lib/locale/lang/zh'; // 中文
import AvueThLocale from './avue/th-TH'; // 泰文
import AvueMxLocale from './avue/es-MX'; // 西班牙语墨西哥
import AvueIdLocale from './avue/id-ID'; // 印尼文

import enUSLocale from './custom/en-US'; // 英文
import zhCNLocale from './custom/zh-CN'; // 中文
import thTHLocale from './custom/th-TH'; // 泰文
import esMXLocale from './custom/es-MX'; // 西班牙语墨西哥
import idIDLocale from './custom/id-ID'; // 印尼文

export const messages = {
  'en-US': {
    ...enUSLocale,
    ...AvueEnLocale,
    ...elementEnLocale,
  },
  'zh-CN': {
    ...zhCNLocale,
    ...elementZhLocale,
    ...AvueZhLocale,
  },
  'th-TH': {
    ...thTHLocale,
    ...AvueThLocale,
    ...elementThLocale,
  },
  'es-MX': {
    ...esMXLocale,
    ...AvueMxLocale,
    ...elementEsLocale,
  },
  'id-ID': {
    ...idIDLocale,
    ...AvueIdLocale,
    ...elementIdLocale,
  },
};
export const language = Store.getters.language;
export default createI18n({
  legacy: false,
  locale: language,
  messages,
});
